import React, { useEffect, useState } from "react";
import { Modal, Checkbox } from "antd";
import { useInstance } from "../../context/instance.context";
import { formatNumberWithCommas } from "../../utils/helper";

const AdminCertificationComponent = ({
    show,
    onClose,
    certifications,
    handleSelect,
    selectedQuote
}) => {
    const [isScrollable, setIsScrollable] = useState(false);
    const { organizationCurrencySymbol } = useInstance();

    useEffect(() => {
        setIsScrollable(certifications?.length > 6);
    }, [certifications]);

    return (
        <Modal
            title="Select Certifications"
            open={show}
            onCancel={onClose}
            footer={null}
            centered
            width={700}
            maskClosable={false}
        >
            <p className="text-muted mb-3">
                Please select the certifications you'd like to add to your quote. Prices are listed below.
            </p>

            <div
                style={{
                    maxHeight: isScrollable ? "400px" : "auto",
                    overflowY: isScrollable ? "auto" : "visible",
                    background: "#f5f5f5",
                    padding: "15px",
                    borderRadius: "6px",
                    border: "1px solid #ddd"
                }}
            >
                {certifications?.map(cert => (
                    <div
                        key={cert._id}
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "12px 15px",
                            background: "#fff",
                            borderRadius: "6px",
                            border: "1px solid #e0e0e0",
                            marginBottom: "10px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.05)"
                        }}
                    >
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <Checkbox
                                checked={selectedQuote?.certifications?.some(item => item?._id === cert._id)}
                                onChange={() => handleSelect(cert)}
                            >
                                {cert.name}
                            </Checkbox>
                        </div>

                        {/* Pricing or Review Required */}
                        {selectedQuote?.selectedProcess <= 2 &&
                            (cert.price !== 0 || !cert.review_required) ? (
                            <div style={{ textAlign: "right" }}>
                                <strong>
                                    {organizationCurrencySymbol}{" "}
                                    {formatNumberWithCommas(cert.price)}
                                </strong>
                                <div style={{ fontSize: "12px", color: "#888" }}>
                                    ({cert.certificationType})
                                </div>
                            </div>
                        ) : (
                            <>
                                {selectedQuote?.selectedProcess <= 2 &&
                                    (cert.price === 0 || cert.review_required) ? (
                                    <div style={{ color: "red" }}>
                                        Review Required
                                    </div>
                                ) : null}
                            </>
                        )}
                    </div>
                ))}
            </div>
        </Modal>
    );
};

export default AdminCertificationComponent;
